<template>
  <div>
    <layout-header title="Otros trámites" subtitle="Otros tramites de la ESI">
      <ets-button
        v-if="isAllowed"
        icon="add"
        title="Generar XML"
        mode="main"
        class="button"
        :loading="isDownloadingXML"
        @click="onSubmit"
      />
    </layout-header>
    <ets-page>
      <template v-if="isAllowed">
        <div class="page">
          <ets-module title="Documentos adjuntos" class="module">
            <table>
              <tr class="uploader-row">
                <th class="label">Reporte a Generar</th>
                <td>
                  <ets-file-uploader
                    @uploaded="getFile($event, 'report')"
                    :display-filename="true"
                    text-button="Añadir Fichero"
                    uploadFieldName="report"
                    id="report"
                    class="uploader"
                    :hasValidation="showErrorsReport"
                    :showAll="showErrors"
                    labelName="Fichero Reporte"
                  />
                </td>
              </tr>
            </table>
          </ets-module>
        </div>
        <popup-errors :displayErrors="displayErrors" :errors="errors" @display-errors="updateDisplayErrors" />
        <popup-generated :displayGenerate="displayGenerate" @display-generate="updateDisplayGenerate" />
        <popup-not-generated
          :displayNotGenerate="displayNotGenerate"
          @display-not-generate="updateDisplayNotGenerate"
          @generate-procedure="generateNewProcedure()"
        />
      </template>
      <forbidden v-else />
    </ets-page>
  </div>
</template>

<script>
import errors from "@/logic/errors";
import { mapState } from "vuex";
import compliance from "@/logic/api/compliance";
import FileLoader from "@/logic/utils/fileLoader";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import Forbidden from "@/components/Forbidden";
import PopupGenerated from "@/components/Popup/PopupGenerated";
import PopupErrors from "@/components/Popup/PopupErrors";
import PopupNotGenerated from "@/components/Popup/PopupNotGenerated";

export default {
  name: "PageOthers",
  components: {
    LayoutHeader,
    Forbidden,
    PopupGenerated,
    PopupErrors,
    PopupNotGenerated
  },
  data: () => ({
    mode: "",
    isDownloadingXML: false,
    data: null,
    identifications: null,
    errors: [],
    displayErrors: false,
    showErrorsReport: false,
    displayGenerate: false,
    showErrors: false,
    fileReport: null,
    showGenerate: false,
    notGenerated: false,
    displayNotGenerate: false
  }),
  computed: {
    ...mapState(["userPermissions"]),
    isAllowed() {
      return this.userPermissions && this.userPermissions.EAFI_E_OtherProcedures;
    }
  },
  methods: {
    getFile(file, inputFile) {
      switch (inputFile) {
        case "report":
          this.fileReport = file.getAll(inputFile)[0];
          break;
      }
    },
    onSubmit() {
      if (this.reportValidation()) {
        this.showErrors = false;
        this.generateXML();
      } else {
        this.displayErrors = true;
        this.showErrors = true;
      }
    },
    async generateXML() {
      this.isDownloadingXML = true;
      const data = await compliance.generateOthers(this.fileReport);
      const generatedFile = new FileLoader(data.data, this.getName(this.fileReport.name) + ".xml", false, "xml");
      generatedFile.download();
      this.displayGenerate = true;
      this.isDownloadingXML = false;
    },
    toggleViews(view) {
      this.showGenerate = false;
      switch (view) {
        case "download":
          this.mode = "";
          break;
        case "generate":
          this.showGenerate = true;
          this.mode = "main";
          break;
      }
    },
    needGenerate(e) {
      this.notGenerated = e;
      this.displayNotGenerate = e;
    },
    generateNewProcedure() {
      this.toggleViews("generate");
      this.displayNotGenerate = false;
    },
    updateDisplayGenerate(e) {
      this.toggleViews("download");
      this.displayGenerate = e;
    },
    updateDisplayErrors(e) {
      this.displayErrors = e;
    },
    updateDisplayNotGenerate(e) {
      this.displayNotGenerate = e;
    },
    onReportsLoaded(reports) {
      if (reports.length === 0) {
        this.generateNewProcedure();
      }
    },
    getExtension(name) {
      const matched = name.match(/\.([0-9a-z]+)$/i);
      if (matched) return matched[1];
    },
    getName(name) {
      return name
        .split(".")
        .slice(0, -1)
        .join(".");
    },
    reportValidation() {
      this.errors = [];
      this.showErrorsReport = false;
      if (this.fileReport === null) {
        this.errors.push(errors.noreportfile);
        this.showErrorsReport = true;
        return false;
      }
      const extension = this.getExtension(this.fileReport.name);
      if (extension !== "xlsx") {
        this.errors.push(errors.wrongextension);
        this.showErrorsReport = true;
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.module {
  ::v-deep .form-input {
    margin: 0.5rem 0;
  }
  ::v-deep .text {
    width: 100%;
    color: #7f8c8d;
    border-bottom: 1px solid #a8b5b6;
    margin-top: 0;
    font-weight: normal;
  }
}
.page .ets-module {
  margin-bottom: 1rem;
}
.input-wrapper {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}
.ets-input {
  display: flex;
  align-items: baseline;
  ::v-deep .input {
    width: 34rem;
    height: 3rem;
  }
  ::v-deep .label {
    width: 8rem;
  }
}
tr {
  line-height: 2.5rem;
}
th {
  text-align: left;
}
td {
  padding-left: 2rem;
}
.label {
  font-weight: bold;
  font-size: 1.3rem;
  font-family: Open Sans Condensed, sans-serif;
}
.tax-year {
  width: 7.6rem;
}
.dropper {
  width: 50%;
}
.uploader {
  ::v-deep .custom-file-upload {
    min-height: 2rem;
    padding: 0.5rem 1rem;
    background-color: #f5f5f5;
    background-image: none;
    border-color: #7f8c8d;
    &:hover {
      background-color: $color-grey5;
      background-image: none;
      border-color: $color-grey;
    }
  }
  ::v-deep .text {
    border-bottom: none;
    color: $color-grey;
    font-size: 1.3rem;
    vertical-align: none;
  }
}
.uploader-row {
  line-height: 0.75rem;
}
.button {
  cursor: pointer;
}
</style>
